import { HapticsProvider, useHaptics } from './HapticsProvider';
import { Impact, HapticsOptions } from './HapticsProvider/types';

export {
  HapticsProvider,
  useHaptics,
  Impact as HapticImpactType,
  HapticsOptions,
};
